import { useChatStore } from '../store/chat.js';

/**
 * 누가 입력 중인지 보여준다.
 *
 * 높이를 항상 차지한다. 나타났다 사라질 때마다 메시지 목록이
 * 밀려 올라가면 읽던 줄을 놓친다.
 */
export function TypingIndicator() {
  const typingUserIds = useChatStore((s) => s.typingUserIds);
  const members = useChatStore((s) => s.members);
  const you = useChatStore((s) => s.you);

  const names = typingUserIds
    .filter((id) => id !== you?.userId)
    .map((id) => members.find((m) => m.userId === id)?.nickname)
    .filter((name): name is string => name !== undefined);

  return (
    <div className="h-5 px-4 text-xs text-neutral-500" aria-live="polite">
      {names.length > 0 && `${names.join(', ')} 님이 입력 중…`}
    </div>
  );
}
